//extracted by mini-css-extract-plugin
export default {"supportResources":"styles_supportResources__ev9g3","textContainer":"styles_textContainer__ZkL3z","cardItem":"styles_cardItem__8vaxy","preLine":"styles_preLine__9cBSU"};;